import { render, staticRenderFns } from "./59.vue?vue&type=template&id=0a20e5b6&scoped=true&"
var script = {}
import style0 from "./59.vue?vue&type=style&index=0&id=0a20e5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20e5b6",
  null
  
)

export default component.exports